import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Domiciliario } from 'src/app/modelos/domiciliario';
import { DomiciliarioService } from 'src/app/services/domiciliario.service';

@Component({
  selector: 'app-certificado-domiciliario-qr',
  templateUrl: './certificado-domiciliario-qr.component.html',
  styleUrls: ['./certificado-domiciliario-qr.component.css']
})
export class CertificadoDomiciliarioQrComponent implements OnInit {

 
   contratantes:any;
   domiciliario: Domiciliario = new Domiciliario();
 
   constructor(private rutaActiva: ActivatedRoute,private domiciliarioService:DomiciliarioService, private spinner: NgxSpinnerService) { }
 
   ngOnInit() {
 
     this.spinner.show();
     this.domiciliarioService.ObtenerPorCuid(this.rutaActiva.snapshot.params.id).subscribe(response => {
        this.spinner.hide();
       this.domiciliario = response.certificados[0];
 
       this.contratantes = response.participantes;
      
      
     });
 
 
   }

}
